'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _nothing = require('uniforms/nothing');

var _nothing2 = _interopRequireDefault(_nothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error(_ref) {
    var children = _ref.children,
        className = _ref.className,
        error = _ref.error,
        errorMessage = _ref.errorMessage,
        props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'error', 'errorMessage']);
    return !error ? _nothing2.default : _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: (0, _classnames2.default)('panel panel-danger text-danger', className) }, (0, _filterDOMProps2.default)(props)),
        _react2.default.createElement(
            'div',
            { className: 'panel-body' },
            children ? children : _react2.default.createElement(
                'div',
                { className: 'panel-heading' },
                _react2.default.createElement(
                    'h4',
                    { className: 'panel-title' },
                    errorMessage
                )
            )
        )
    );
};

exports.default = (0, _connectField2.default)(Error, { initialValue: false });


/*****************
 ** WEBPACK FOOTER
 ** ./~/uniforms-bootstrap3/ErrorField.js
 ** module id = ./node_modules/uniforms-bootstrap3/ErrorField.js
 ** module chunks = 0
 **/